import { render, staticRenderFns } from "./OrgaosContratosForm.vue?vue&type=template&id=1a331c9e&scoped=true"
import script from "./OrgaosContratosForm.vue?vue&type=script&lang=js"
export * from "./OrgaosContratosForm.vue?vue&type=script&lang=js"
import style0 from "./OrgaosContratosForm.vue?vue&type=style&index=0&id=1a331c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a331c9e",
  null
  
)

export default component.exports